import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'


export default {
    name: 'PaymentConfirmation',
    components: {
        IconBase,
        IconForwardBack
    },
    data () {
        return {
           
        }
    },
    methods: {
       
    },
    mounted () {
        
    },
    watch : {

    },
}